import './DropDown.scss';
import React from 'react';
import { Dropdown } from 'antd';
import Link from 'Components/Shared/Link/Link';

export interface IDropdown {
  displayName: string;
  formattedName: string;
  localPath?: string;
  items: Array<{
    id: string;
    displayName: string;
    formattedName: string;
    localPath: string;
  }>;
}

const DropDown: React.SFC<IDropdown> = ({ items, children }) => {

  const dropdownList = ( 
    <div className='dropdown-list'>
      { items.map(i => <Link key={ i.id } { ...i }/>) }
    </div>
  );

  return (
    <Dropdown overlay={ dropdownList } placement='bottomCenter' trigger={ ['click'] }>
      { children }
    </Dropdown>
  );
} 

export default DropDown;


// WEBPACK FOOTER //
// ./src/components/MenuMain/DropDown/DropDown.tsx